import React from 'react';
import './CTABand.css';

export default function CTABand() {
  return (
    <section className="cta-band">
      <div className="cta-band__inner">
        <h2>Ready to Go <em>Beyond</em>?</h2>
        <p>
          Let's build something remarkable. Your free audit takes just 30 minutes and comes with zero obligation.
        </p>
        <a href="#contact" className="btn btn--white">Book Your Free Audit →</a>
      </div>
    </section>
  );
}